import { Link } from 'react-router-dom'
import { Container } from './Container'
import { cn } from '@/shared/utils'

interface FooterLink {
  label: string
  href: string
}

interface FooterSection {
  title: string
  links: FooterLink[]
}

interface FooterProps {
  sections: FooterSection[]
  description?: string
  copyright?: string
  className?: string
}

export function Footer({ 
  sections, 
  description, 
  copyright = "© 2025 SitRepp.io. Built for the overlanding community.",
  className 
}: FooterProps) {
  return (
    <footer className={cn('py-16 bg-background border-t', className)}>
      <Container size="app">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">SitRepp.io</h4>
            {description && (
              <p className="text-muted-foreground text-sm">
                {description}
              </p>
            )}
          </div>
          
          {/* Dynamic Sections */}
          {sections.map((section, index) => (
            <div key={index} className="space-y-4">
              <h4 className="font-semibold text-foreground">{section.title}</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link 
                      to={link.href} 
                      className="hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="border-t border-border pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            {copyright}
          </p>
        </div>
      </Container>
    </footer>
  )
}
